import {Directive, effect, inject, input, TemplateRef, ViewContainerRef} from "@angular/core";
import {LayoutService, ScreenSize} from "../layout/layout.service";

@Directive({selector: "[breakpoints]"})
export class BreakpointsDirective {
    public readonly breakpoints = input.required<ScreenSize[]>();

    private readonly layoutService = inject(LayoutService);
    private readonly templateRef = inject(TemplateRef);
    private readonly viewContainer = inject(ViewContainerRef);

    constructor() {
        effect(() => {
            this.viewContainer.clear();
            if (this.breakpoints().includes(this.layoutService.screenSize())) {
                this.viewContainer.createEmbeddedView(this.templateRef);
            }
        });
    }
}
